<template>
  <div class="login">
    <div class="login-header">
      <h2>登录/注册</h2>
    </div>
    <div class="login-form">
      <van-field
        v-model="username"
        type="tel"
        label="账号"
        placeholder="请输入手机号"
        left-icon="phone-o"
      />
      <van-field
        v-model="password"
        type="password"
        label="密码"
        placeholder="请输入密码"
        left-icon="lock"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="handleLogin">
          注册/登录
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    async handleLogin() {
      if (!this.username || !this.password) {
        this.$toast('请输入账号和密码');
        return;
      }
      try {
        const { data } = await this.$http.post('/login', {
            username: this.username,
            password: this.password
        });
        if (data.success) {
             localStorage.setItem('token', 'api-token');
             localStorage.setItem('user', JSON.stringify(data.user));
             this.$toast.success('登录成功');
             setTimeout(() => {
               this.$router.push('/user');
             }, 1000);
        }
      } catch (e) {
         this.$toast.fail('账号或密码错误');
      }
    }
  }
}
</script>

<style scoped>
.login {
  padding: 20px;
  height: 100vh;
  background-color: #fff;
}
.login-header {
  margin-top: 50px;
  margin-bottom: 40px;
  text-align: center;
}
</style>
